var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletDisconnectedLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 16C2.9 16 1.95833 15.6083 1.175 14.825C0.391667 14.0417 0 13.1 0 12V4C0 2.9 0.391667 1.95833 1.175 1.175C1.95833 0.391667 2.9 0 4 0H16C17.1 0 18.0417 0.391667 18.825 1.175C19.6083 1.95833 20 2.9 20 4V12C20 13.1 19.6083 14.0417 18.825 14.825C18.0417 15.6083 17.1 16 16 16H4ZM4 4.25H16C16.4833 4.25 16.9375 4.325 17.3625 4.475C17.7875 4.625 18.1667 4.84167 18.5 5.125V4C18.5 3.3 18.2583 2.70833 17.775 2.225C17.2917 1.74167 16.7 1.5 16 1.5H4C3.3 1.5 2.70833 1.74167 2.225 2.225C1.74167 2.70833 1.5 3.3 1.5 4V5.125C1.83333 4.84167 2.2125 4.625 2.6375 4.475C3.0625 4.325 3.51667 4.25 4 4.25ZM1.575 7.65L13.5 10.525C13.6167 10.5583 13.7375 10.5625 13.8625 10.5375C13.9875 10.5125 14.0917 10.4583 14.175 10.375L18.175 7.025C17.9583 6.64167 17.6583 6.33333 17.275 6.1C16.8917 5.86667 16.4667 5.75 16 5.75H4C3.41667 5.75 2.9 5.92917 2.45 6.2875C2 6.64583 1.70833 7.1 1.575 7.65Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletDisconnectedLight);
export default __webpack_public_path__ + "static/media/wallet_disconnected_light.8f86a96961dd83d2b63153cbb682b7a8.svg";
export { ForwardRef as ReactComponent };